// get distance between two points. Callers must pass x1/y1/x2/y2 already normalized to
// consistent data-space units (FR-008) - this function performs a plain, symmetric
// Pythagorean distance and does not apply any additional per-axis scaling.
function getDistanceBetweenPoints(
  x1: number,
  y1: number,
  x2: number,
  y2: number
): string {
  return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2)).toFixed(2);
}

export default getDistanceBetweenPoints;
